import styled from 'styled-components';
import { Icon } from 'src/components/general/icon';
import { FlexColumn } from 'src/components/layout/flex-column';
import { FlexRow } from 'src/components/layout/flex-row';

const TitleContainer = styled(FlexRow)`
  margin-bottom: 15px;
`;

const Title = styled.span`
  -webkit-text-stroke: 1px rgba(0, 0, 0, 0);
  color: ${({ theme }) => theme.colors.smalt};
  font-family: ${({ theme }) => theme.font.medium};
  font-size: 13px;
  letter-spacing: -0.26px;
  line-height: 15px;
`;

const TitleIcon = styled(Icon)`
  margin-right: 5px;

  svg {
    height: 14px;
    width: 14px;

    path {
      fill: ${({ theme }) => theme.colors.gogo};
    }
  }
`;

const MainContentContainer = styled(FlexRow)`
  flex-wrap: wrap;
`;

type ContactInteractionExtraDetailsProps = {
  topContent: React.ReactNode;
  mainContent: React.ReactNode;
  bottomContent?: React.ReactNode;
  title: string;
  testId?: string;
};

export const ContactInteractionExtraDetails = ({
  topContent,
  mainContent,
  bottomContent,
  title,
  testId,
}: ContactInteractionExtraDetailsProps) => {
  return (
    <FlexColumn data-lgg-id={testId}>
      <TitleContainer>
        <TitleIcon type="iconAi" />
        <Title>{title}</Title>
      </TitleContainer>
      {topContent}
      <MainContentContainer>{mainContent}</MainContentContainer>
      {bottomContent}
    </FlexColumn>
  );
};
